// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  email: getIcon('ic_mail'),
  Add: getIcon('ic_booking'),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Subadmin',
    items: [
      { title: 'dashboard', path: '/dashboard/dashboard', icon: ICONS.dashboard },
      { title: 'Request To Join CSP', path: '/dashboard/Requesttojoin', icon: ICONS.email },
      { title: 'Add service provider', path: '/dashboard/Addcsp', icon: ICONS.Add },
      { title: 'Community service provider', path: '/dashboard/CSP', icon: ICONS.user },
      { title: 'Payment Receive', path: '/dashboard/payment', icon: ICONS.user },
      { title: 'Loan Payment Schedule', path: '/dashboard/loanpaymentschedule', icon: ICONS.user },
      { title: 'Loan Payment', path: '/dashboard/loanpayment', icon: ICONS.user },
      { title: 'RePayment', path: '/dashboard/repayment', icon: ICONS.user },
      { title: 'Donate To Borrower', path: '/dashboard/paytoborrower', icon: ICONS.user },

      // { title: 'order', path: '/dashboard/order', icon: ICONS.ecommerce },
      // { title: 'Three', path: '/dashboard/three', icon: ICONS.analytics },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     {
  //       title: 'user',
  //       path: '/dashboard/user',
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'Four', path: '/dashboard/user/four' },
  //         { title: 'Five', path: '/dashboard/user/five' },
  //         { title: 'Six', path: '/dashboard/user/six' },
  //       ],
  //     },
  //   ],
  // },
];

export default sidebarConfig;
